module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/careers-small.652b27128897d5faa2c798c56bc21b17.jpg";